import { Navigation } from './Navigation';
import { Footer } from './Footer';
import { useLocation } from 'react-router-dom';

interface AppLayoutProps {
 children: React.ReactNode;
}

export function AppLayout({ children }: AppLayoutProps) {
 const location = useLocation();
 const isHomePage = location.pathname === '/';

 return (
  <div className='min-h-screen bg-background text-foreground font-sans'>
   <div className='fixed inset-0 z-0 pointer-events-none'>
    <div className='w-full h-full bg-[radial-gradient(#27272a_1px,transparent_1px)] [background-size:24px_24px] opacity-20'></div>
   </div>

   {/* Navigation handles its own interception */}
   <Navigation />

   <main className='max-w-7xl mx-auto px-6 py-12 relative z-10'>
    {children}
   </main>

   {isHomePage && <Footer />}
  </div>
 );
}
